import { useEffect } from "react";
import { useTranslation } from "../hooks/useTranslation";

export function MetaUpdater() {
  const t = useTranslation();

  useEffect(() => {
    document.title = `${t.title} – ${t.subtitle}`;

    const meta = document.querySelector<HTMLMetaElement>(
      'meta[name="description"]',
    );
    if (meta) {
      meta.setAttribute("content", t.metaDescription);
    } else {
      const newMeta = document.createElement("meta");
      newMeta.name = "description";
      newMeta.content = t.metaDescription;
      document.head.appendChild(newMeta);
    }
  }, [t.metaDescription, t.title, t.subtitle]);

  return null;
}
